import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute component that checks if user is authenticated
 * Redirects to landing page if not logged in
 */
function ProtectedRoute({ children }) {
  const user = localStorage.getItem('user');
  const isLoggedIn = !!user;

  if (!isLoggedIn) {
    // Redirect to landing page if not authenticated
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
